export enum Theme {
  ANYLOGI = 'anylogi',
  ANYX = 'any-x',
  ANYCHAT = 'anychat',
}
